import React from 'react'
import _ from 'lodash'

import TicketCorrespondenceLogItem from 'Components/Tickets/Correspondence/Log/Item'

const TicketCorrespondenceLog = ({ comments, loading }) => {

  const orderedComments = _.orderBy(comments, 'created_at', 'desc')

  if (loading) {
    return (
      <p>Loading . . .</p>
    )
  }

  if (_.isEmpty(orderedComments)) {
    return (
      <p>There is no correspondence, start a conversation!</p>
    )
  }

  return(
    <div>
      {_.map(orderedComments,
        comment => <TicketCorrespondenceLogItem key={`${comment.commentable_type}-${comment.commentable_id}-${comment.id}`} comment={comment} />)}
    </div>
  )
}

export default TicketCorrespondenceLog
